import { Appearance } from './types';

export type FrameSize = {
  width: string;
  height: string;
};

type FrameSizes = {
  collapsed: {
    [Appearance.Large]: {
      mobile: FrameSize;
      desktop: FrameSize;
    };
    [Appearance.Small]: {
      mobile: FrameSize;
      desktop: FrameSize;
    };
  };
  narrow: {
    mobile: FrameSize;
    desktop: FrameSize;
  };
  wide: {
    mobile: FrameSize;
    desktop: FrameSize;
  };
  fullscreen: {
    mobile: FrameSize;
    desktop: FrameSize;
  };
};

export const iframeSizes: FrameSizes = {
  collapsed: {
    [Appearance.Large]: {
      mobile: {
        width: '100%',
        height: '210px',
      },
      desktop: {
        width: '320px',
        height: '215px',
      },
    },
    [Appearance.Small]: {
      mobile: {
        width: '154px',
        height: '236px',
      },
      desktop: {
        width: '154px',
        height: '235px',
      },
    },
  },
  narrow: {
    mobile: {
      width: '100%',
      height: '100%',
    },
    desktop: {
      width: '320px',
      height: '95%',
    },
  },
  wide: {
    mobile: {
      width: '100%',
      height: '100%',
    },
    desktop: {
      width: '100%',
      height: '100%',
    },
  },
  fullscreen: {
    mobile: {
      width: '100%',
      height: '100%',
    },
    desktop: {
      width: '100%',
      height: '100%',
    },
  },
};

export const mobileBreakpoint = 400;

export const DH_PARAMS_QUERY_STRING_KEY = 'dhuwParams';
